
$(document).ready(function() {
    messaging.init();

    $('[data-ask]').click(function() {
        messaging.askContentDialog($(this), $(this).attr("data-title"), null, {
            yesButton: $(this).attr('data-yes-btn') || 'Ja, löschen',
            content: $(this).attr('data-content'),
        });
        return false;
    });

    $('[data-popupmessage]').click(function() {
        var me = $(this);
        var message = $(this).attr('data-popupmessage');
        if (['.', '#'].indexOf(message.substr(0, 1)) !== -1) {
            message = me.find(message).html();
        }
        messaging.showMessagePopup(message, $(this).attr("data-title"));
        return false;
    });

    // tests
    // var element = $('<a href=""></a>');
    // messaging.askContentDialog(element, 'Frage?', 'Welche Farbe hat der Himmel?');
    // messaging.showPermanentGlobalMessage("danger", "titel hier", "nachricht ist etwas länger aber sicher nicht allzu lange oder etwas doch?");
    // messaging.showPermanentGlobalMessage("warning", "titel hier", "nachricht ist etwas länger aber sicher nicht allzu lange oder etwas doch?");
    // messaging.showPermanentGlobalMessage("success", "titel hier", "nachricht ist etwas länger aber sicher nicht allzu lange oder etwas doch?");
});

$(document).on('content-ready', function (ev, container) {
    container.find('[data-ask-dialog]').click(function() {
        messaging.askYesNoDialog($(this));
        return false;
    });

    container.find('.modal-footer [type="submit"]').click(function() {
        container.find('form').submit();
        return false;
    });
});

var messaging = {
    messageContainer: null,

    init: function() {
        messaging.messageContainer = $('#global-messaging .messaging-box');
    },

    showGlobalMessage: function(type, title, message, hideTimeout) {
        messaging.showPermanentGlobalMessage(type, title, message, hideTimeout);
    },

    showPermanentGlobalMessage: function(type, title, message, hideTimeout) {
        if (type === 'success' && !hideTimeout) {
            hideTimeout = 2000;
        }
        hideTimeout = hideTimeout || 12000;

        var options = {
            type: type,
            timeOut: hideTimeout,
            progressBar: hideTimeout >= 0,
            toastClass: 'toastr',
        };

        switch (type) {
            case "warning":
                toastr.warning(message, title, options);
                break;
            case "error":
            case "danger":
                toastr.error(message, title, options);
                break;
            case "success":
                toastr.success(message, title, options);
                break;
            case "info":
                toastr.info(message, title, options);
                break;
        }
    },

    askContentDialog: function(element, title, htmlContent, options) {
        options = options || {};
        var dialog = notification.notifyPopup(title, '<div class="loading">'+(htmlContent || options.content || '')+'</div>', {});

        if (element.attr('data-url') || element.attr('data-ajax-url')) {
            notification.addButton(dialog, {
                caption: options.yesButton || "Weiter",
                cssClass: "btn btn-success action-enter",
                callback: function(notifyEl, btn) {
                    btn.startProcess();
                    if (options.onYes) {
                        return options.onYes();
                    }
                    if (element.attr('data-url')) {
                        location.href = element.attr('data-url');
                    } else if (element.attr('data-ajax-url')) {
                        connection.getJson(element.attr('data-ajax-url'), {
                            onComplete: () => {
                                notification.close(dialog);
                            },
                        });
                    }
                }
            });
        }
        notification.addButton(dialog, {
            caption: options.noButton || "Schliessen",
            cssClass: "btn btn-danger",
            callback: function() {
                return true;
            }
        });

        var dialogEl = dialog.find('.message');
        if (element.attr('data-ask') || '' !== '') {
            dialogEl.html(element.attr('data-ask'));
            dialogEl.removeClass('loading');
        }
        // $(document).on('keyup', function($ev) {
        //     if ($ev.key === "Enter") {
        //         debugger;
        //         $('.modal-dialog .action-enter').trigger('click');
        //         // @todo: implement yes-action
        //     }
        // });

        if (element.attr('data-content')) {
            connection.getHtmlPart(element.attr('data-content'), {
                onSuccess: function (data) {
                    dialogEl.html(data);
                    var btns = dialogEl.find('.buttons').find('>button, >span, >a');
                    btns.appendTo(dialogEl.closest('.modal-content').find('.modal-footer'));

                    onContentReady(dialogEl.closest('.modal-content'));
                    dialogEl.trigger('onLaded');
                },
                onComplete: function () {
                    dialogEl.removeClass('loading');
                },
            });
        }

        return dialog;
    },

    askYesNoDialog: function(targetElement) {
        BootstrapDialog.show({
            type: targetElement.attr('data-type') || BootstrapDialog.TYPE_WARNING,
            title: targetElement.attr('data-title') || targetElement.attr('title'),
            closable: targetElement.attr('data-title') || 'false' === 'true',
            message: function (dialog) {
                return $('<div>'+targetElement.attr('data-question')+'</div>');
            },
            onshown: function(dialogRef) {
                dialogRef.$modalFooter.prepend('<div class="dialog-error-message mr-auto text-danger"></div>');
                dialogRef.$modalBody.find('textarea').keyup((ev) => {
                    ev.stopPropagation();
                });
            },
            buttons: [{
                label: 'Ja',
                cssClass: 'btn-outline-primary',
                hotkey: 13, // Enter.
                action: function (dialog) {
                    targetElement.trigger('answer-yes');
                    connection.getJson(targetElement.attr('data-ask-dialog'), {
                        onSuccess: function(data) {
                            targetElement.trigger('answer-yes-success');
                            dialog.close();
                        },
                    });
                }
            }, {
                label: 'Nein',
                cssClass: 'btn-outline-dark',
                hotkey: 27, // Esc.
                action: function (dialog) {
                    targetElement.trigger('answer-no');
                    dialog.close();
                },
            }]
        });
    },

    askYesNo: function(title, question, onYes, onNo) {
        BootstrapDialog.show({
            type: BootstrapDialog.TYPE_WARNING,
            title: title,
            closable: false,
            message: function (dialog) {
                return $('<div>'+question+'</div>');
            },
            onshown: function(dialogRef) {
                dialogRef.$modalBody.find('textarea').keyup((ev) => {
                    ev.stopPropagation();
                });
            },
            buttons: [{
                label: 'Ja',
                cssClass: 'btn-outline-primary',
                hotkey: 13, // Enter.
                action: function (dialog, ev) {
                    if (onYes) {
                        var result = onYes(dialog.$modal);
                        if (result !== false) {
                            dialog.close();
                        }
                    } else {
                        dialog.close();
                    }
                }
            }, {
                label: 'Nein',
                cssClass: 'btn-outline-dark',
                hotkey: 27, // Esc.
                action: function (dialog) {
                    if (onNo) onNo();
                    dialog.close();
                }
            }]
        });

        // var dialog = notification.notifyPopup(title, '<div>'+question+'</div>', {});
        // notification.addButton(dialog, {
        //     caption: "Ja",
        //     cssClass: "btn btn-success",
        //     callback: function(notifyEl) {
        //         if (onYes) {
        //             var result = onYes(notifyEl);
        //             return !result;
        //         }
        //         return true;
        //     }
        // });
        // notification.addButton(dialog, {
        //     caption: "Nein",
        //     cssClass: "btn btn-danger",
        //     callback: function() {
        //         if (onNo) onNo();
        //         return true;
        //     }
        // });
    },

    showMessagePopup: function(message, title) {
        var dialog = notification.notifyPopup(title || 'Nachricht', '<div>'+message+'</div>', {});
        notification.addButton(dialog, {
            caption: "OK",
            cssClass: "btn btn-success",
            callback: function(notifyEl) {
                return true;
            }
        });
    },

    showElModalWindow: function (el, options) {
        if (!options) options = {};
        options = $.extend({
            id: el.attr("data-showasmodal"),
            isUnique: el.is('[data-unique]'),
            title: el.attr("data-modaltitle") || '',
            closeIcon: el.attr("data-close-btn"),
            cssClass: el.attr('data-cssClass') || '',
            closeByBackdrop: (el.attr('data-bgclose') ? el.attr('data-bgclose') === 'true' : false),
            size: el.attr('data-size') || BootstrapDialog.SIZE_WIDE,
            content: el.attr('data-content'),
            contentUrl: el.attr("href") || el.attr("data-href"),
        }, options);
        messaging.showModalWindow(options);
    },

    showModalWindow: function (options) {
        if (!options) options = {};
        var id = options.id;
        var existing = $(".modal-" + id);
        var existingOpen = $('.modal.show');
        var d = BootstrapDialog.dialogs;

        if (existing.length >= 1) {
            if (!options.isUnique) {
                if (existingOpen.length > 0) d[existingOpen.attr('id')].close();
                d[existing.attr('id')].open();
                return;
            } else {
                // BootstrapDialog.closeAll();
                d[existing.attr('id')].close();
                existing.remove();
                $('.modal-backdrop').remove();
            }
        }

        BootstrapDialog.show({
            title: options.title,
            closeIcon: options.closeIcon,
            type: 'type-info',
            message: '<div class="loader-show"><div class="loader text-center"><svg class="circular" style="max-height:50px;" viewBox="25 25 50 50"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/></svg></div></div>',
            cssClass: 'modal-dialog-scrollable modal-' + id + ' ' + (options.cssClass || ''),
            closeByBackdrop: options.closeByBackdrop || false,
            size: options.size || BootstrapDialog.SIZE_WIDE,
            autodestroy: false,
            buttons: options.buttons,
            onshown: function (modal) {
                if (options.content) {
                    modal.$modal.find('.modal-body').addClass('scrollable').html($(options.content).html());
                    if (!options.title) modal.$modal.find('.modal-header .bootstrap-dialog-title').html(modal.$modal.find('.modal-body .modal-title').html());
                    var footerEl = modal.$modal.find('.modal-body .modal-footer-content');
                    if (footerEl.length === 1) {
                        modal.$modal.find('.modal-footer').html(footerEl.html());
                        modal.$modal.find('.modal-footer').show();
                    }
                    modal.$modal.find('[data-close]').click(function() {
                        modal.close();
                    });
                    onContentReady(modal.$modal);
                    if (options.onLoaded) options.onLoaded(modal);
                } else if (options.contentUrl) {
                    if (modal.$modal.find('.loader').length === 1) {
                        $.ajax({
                            url: options.contentUrl,
                            type: 'get',
                            dataType: 'html',
                            cache: false,
                            data: {nolayout: true},
                            success: function (response) {
                                modal.$modal.find('.modal-body').addClass('scrollable').html('<div class="scroll-body">' + response + '</div>');
                                modal.$modal.find('.modal-header .bootstrap-dialog-title').html(modal.$modal.find('.modal-body .modal-title').html());
                                var footerEl = modal.$modal.find('.modal-body .modal-footer-content');
                                if (footerEl.length === 1) {
                                    modal.$modal.find('.modal-footer').html(footerEl.html());
                                    modal.$modal.find('.modal-footer').show();
                                    modal.$modal.find('.modal-footer').find('button[type=submit],.submit').click(function() {
                                        var button = $(this);
                                        button.startProcess();
                                        modal.$modal.find('form').on('onComplete', function() {
                                            button.endProcess();
                                        });
                                        modal.$modal.find('form').submit();
                                    });
                                }

                                modal.$modal.find('[data-close]').click(function() {
                                    modal.close();
                                });
                                onContentReady(modal.$modal);
                                if (options.onLoaded) options.onLoaded(modal);
                            },
                            error: function (response) {
                                modal.$modal.find('.modal-body').html('Fehler beim laden der Inhalte.');
                            }
                        });
                    }
                }
            },
            onhide: function(modal) {
                if (options.onHide) options.onHide(modal);
            }
        });
    },

};
window.messaging = messaging;
